import { STASH_ANSWER_REQUEST, SUBMIT_ANSWERS_SUCCESS } from '../actions/actions'
import dotProp from 'dot-prop-immutable-chain'

export default function answersStash(state = {}, action) {
  switch (action.type) {
    case STASH_ANSWER_REQUEST:
      const {
        answer: { questionId, optionId },
      } = action

      return dotProp(state)
        .set(`answers.${questionId}`, optionId)
        .value()

    case SUBMIT_ANSWERS_SUCCESS: // empty stash after successful submits
      return dotProp(state)
        .set(`answers`, {})
        .value()

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/answersStash.js